import { useSelector, useDispatch } from "react-redux";
import { RootState } from "../state/reducers";
import { setIsCroqeeTutorialDone } from "../state/actions";

const useCroqeeTutorial = () => {
  const isCroqeeTutorialDone = useSelector((state: RootState) => state.isCroqeeTutorialDone);
  const dispatch = useDispatch();

  const setIsCroqeeTutorialDoneHandler = (payload: boolean) => {
    dispatch(setIsCroqeeTutorialDone(payload) as any);
  };

  return {
    isCroqeeTutorialDone,
    setIsCroqeeTutorialDone: setIsCroqeeTutorialDoneHandler,
  };
};

export default useCroqeeTutorial;
